import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { chapters } from "@/mocks/chapters";

const statusStyle: Record<string, string> = {
  已收录: "bg-secondary-100 text-secondary-800",
  更新中: "bg-accent-100 text-accent-800",
  完结: "bg-primary-100 text-primary-700",
};

export default function ChapterPreview() {
  const preview = chapters.slice(0, 8);
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <SectionHeading
              align="left"
              kicker="追更进度"
              title="第几话速查表"
              desc="按剧情阶段整理的关键话数一览，快速定位当前追到哪、后面还有哪些阶段。"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="text-sm leading-relaxed text-foreground-600">
                主篇《斗罗大陆》漫画剧情已整理收录至完结篇，从觉醒到成神的完整话数脉络均可在此回看。
              </p>
              <Link
                to="/chapters"
                className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                查看完整话数列表
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:col-span-2">
            {preview.map((c) => (
              <div
                key={c.no}
                className="flex items-center justify-between rounded-lg border border-background-200 bg-background-50 px-4 py-3"
              >
                <div className="flex items-center gap-3">
                  <span className="font-heading text-sm font-bold text-primary-600">{c.no}</span>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">{c.title}</p>
                    <p className="text-xs text-foreground-400">{c.arc}</p>
                  </div>
                </div>
                <span className={`rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${statusStyle[c.status]}`}>
                  {c.status}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}